import { AssignmentRow } from './types';

export const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
});

let idCounter = 1;

export const generateRow = (position: number): AssignmentRow => {
    idCounter += 1;
    return {
        id: idCounter,
        position: position,
        order: position,
        pay_rule_id: null,
        work_rule_id: null,
        start_hour: '',
        end_hour: '',
        min_shift: '',
        max_shift: '',
        days_week: new Set(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']),
        planned: true,
        unplanned: true
    };
};
